/**
 * Read current user info from the stored JWT (payload only, no verification).
 * Used for UI decisions like showing admin-only controls.
 */
export function getIsAdmin(): boolean {
    const token = localStorage.getItem('rfq_access_token');
    if (!token) return false;
    try {
        const parts = token.split('.');
        if (parts.length !== 3) return false;
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        return Boolean(payload.is_admin);
    } catch {
        return false;
    }
}
